import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue'
import AddInvoiceFileField from './AddInvoiceFileField.vue'
import { UploadedFileType } from '@/types/partials'

import { useAdviceDocuments } from '@/composables/useAdviceDocuments'

interface IProps {
    id: string
    error?: boolean
    disableRemove?: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    id: { type: String, required: true, default: '' },
    error: { type: Boolean, required: false, default: false },
    disableRemove: { type: Boolean, required: false, default: false }
  },
  setup(__props: any) {

const props = __props as { id: string, error: boolean, disableRemove: boolean }
const {
    removeCorrectionFile,
    addCorrectionFile,
    setCorrectionValue,
    setInvoiceNumber,
    fetchInvoiceData,
    correctionValue,
    correctionFile,
    setKsefNumber,
} = useAdviceDocuments()



const showField = ref<boolean>(false)
const inputCorrectionValue = ref<string>('')

fetchInvoiceData().then(() => {
    inputCorrectionValue.value = correctionValue.value
    showField.value = true
})

const correctionFilePresent = computed(() => {
    if (correctionFile.value) {
        return Object.keys(correctionFile.value).length > 0
    }
    return false
})
const onFilesUpload = (files: UploadedFileType[]) => {
    addCorrectionFile(files[0])
}
const onInputChange = (inputValue: string) => {
    setCorrectionValue(inputValue)
}
const onInvoiceNumberChange = (inputValue: string) => {
    setInvoiceNumber(inputValue)
}
const onKsefNumberChange = (inputValue: string) => {
    setKsefNumber(inputValue)
}

return (_ctx: any,_cache: any) => {
  return (showField.value)
    ? (_openBlock(), _createBlock(AddInvoiceFileField, _mergeProps({ key: 0 }, props, {
        "input-value": inputCorrectionValue.value,
        "file-present": _unref(correctionFilePresent),
        "file-name": _unref(correctionFile).name,
        "file-upload-button-text": 'Dodaj korektę',
        "allow-negative-invoice-value": true,
        onFileRemove: _unref(removeCorrectionFile),
        onFilesUpload: onFilesUpload,
        onInputChange: onInputChange,
        onInvoiceNumberChange: onInvoiceNumberChange,
        onKsefNumberChange: onKsefNumberChange
      }), null, 16, ["input-value", "file-present", "file-name", "onFileRemove"]))
    : _createCommentVNode("", true)
}
}

})